import { PageHead } from "@/components/site/PageHead";
import { FadeUp, Eyebrow } from "@/components/site/Reveal";
import { Heritage } from "@/components/home/Heritage";
import { Marquee } from "@/components/site/Marquee";
import { ContactBand } from "@/components/site/ContactBand";

const STEPS = [
  { t: "Raw materials", d: "Finest quality resins, pigments and solvents are chosen for each ink system." },
  { t: "Production", d: "Inks are made in our own production facility in Dada Nagar, Kanpur." },
  { t: "Range", d: "Lamination, surface printing, specialty packaging inks and reducers." },
  { t: "Supply", d: "Orders from 100 kg, with bulk quantities at reasonable prices." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHead eyebrow="About Tide Inchem" lines={["Ink makers", "from Kanpur,", <span key="y" className="text-[#FF5A00]">since 1997.</span>]}>
        <FadeUp className="mt-10 grid gap-6 md:grid-cols-12">
          <p className="text-lg leading-relaxed text-zinc-700 md:col-span-6 md:col-start-7">
            Tide Inchem Private Limited is a manufacturer and supplier of a wide range of quality printing inks — extrusion lamination, foil, gravure, metallic, reverse lamination, poly and woven sack inks, and ink reducer. We serve the printing and packaging industries from Kanpur, Uttar Pradesh.
          </p>
        </FadeUp>
      </PageHead>
      <Marquee />
      <section className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
        <Eyebrow>How we work</Eyebrow>
        <div className="mt-12 grid grid-cols-1 border-l border-t border-black/15 md:grid-cols-4">
          {STEPS.map((s, i) => (
            <FadeUp key={s.t} delay={i * 0.08} className="border-b border-r border-black/15 p-7 md:p-9" data-testid={`about-step-${i}`}>
              <span className="font-wide text-5xl font-black text-[#FFC400]">0{i + 1}</span>
              <h3 className="font-wide mt-8 text-xl font-bold uppercase tracking-tight">{s.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-700">{s.d}</p>
            </FadeUp>
          ))}
        </div>
      </section>
      <Heritage />
      <ContactBand />
    </div>
  );
}
